/**
 * @file 模型库页模型列表元素
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {Rate} from 'antd';
import {IModelBaseListItem} from '../../type';
import VerticalEllipsis from '../../../../components/vertical-ellipsis/VerticalEllipsis';

interface IProps {
    model: IModelBaseListItem;
}

const ModelBaseItem: React.FC<IProps> = props => {
    const {
        nameCn,
        applyCase,
        categoryName,
        score,
        summary,
        detailUrl
    } = props.model;

    return (
        <div className="model-base-item">
            <a href={detailUrl}>
                <div className="model-base-item-name-wrap">
                    <span className="model-base-item-name">{nameCn}</span>
                    <Rate value={score} disabled className="model-base-item-rate" />
                </div>
                <div className="model-base-item-info">
                    <span className="model-base-item-category">
                        <span className="model-base-item-category">类别：</span>{categoryName}
                    </span>
                    <span className="model-base-item-network">
                        <span>应用：</span>{applyCase}
                    </span>
                </div>
                <div className="model-base-item-summary">
                    <VerticalEllipsis>
                        {summary}
                    </VerticalEllipsis>
                </div>
                <div className="model-base-item-link-group">
                <span
                    className="model-base-item-link"
                >
                    查看详情
                </span>
                </div>
            </a>
        </div>
    );
};

export default ModelBaseItem;
